export enum RedirectMessage {
  DOKUMENT_SEND_SUCCESS = 'dokument_send_success',
  DOKUMENT_ZUS_SEND_SUCCESS = 'dokument_zus_send_success',
}

interface RedirectMessageContent {
  title: string;
  description: string;
}

export const RedirectMessageContents: Partial<
  Record<RedirectMessage, RedirectMessageContent>
> = {
  [RedirectMessage.DOKUMENT_SEND_SUCCESS]: {
    title: 'Informacja o wysłaniu wniosku',
    description:
      '<p>Wniosek został wysłany.</p><p><strong>Uwaga!</strong> Potwierdzeniem skutecznego wysłania wniosku jest otrzymanie na adres e-mail UPO – Urzędowego Poświadczenia Przedłożenia.</p>',
  },
  [RedirectMessage.DOKUMENT_ZUS_SEND_SUCCESS]: {
    title: 'Informacja o wysłaniu wniosku',
    description:
      '<p>Wniosek został wysłany.</p><p><strong>Uwaga!</strong> Potwierdzeniem skutecznego wysłania wniosku jest otrzymanie na adres e-mail UPO – Urzędowego Poświadczenia Przedłożenia.</p>' +
      '<p>Wszelkie informacje o wynikach postępowania wszczętego w sprawie złożonego wniosku znajdą Państwo na portalu eZUS (<a href="https://www.zus.pl/" target="_blank" rel="noopener noreferrer">www.zus.pl</a>), na swoim koncie osobistym.</p>',
  },
};
